export default __webpack_public_path__ + "static/media/location.63c6e9e3.svg";